import PropTypes from "prop-types";

import { rootCss } from "./QuestionText.style";

const propTypes = {
  id: PropTypes.string,
  isStatic: PropTypes.bool,
  text: PropTypes.string,
  isPreviewMode: PropTypes.bool,
};

const QuestionText = ({ id, isStatic, text, isPreviewMode }) => {
  return isStatic ? (
    <p
      css={rootCss(isPreviewMode)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: text || "" }}
    />
  ) : (
    <legend
      css={rootCss(isPreviewMode)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: text || "" }}
      id={id}
    />
  );
};

QuestionText.propTypes = propTypes;

export default QuestionText;
